function transformElement(key, elements, elementsIndex) {
  const position = elementsIndex[key];
  const elementNode = elements[position];

  if (!elementNode || !elementNode.props) {
    return { isVisible: false };
  }

  const { attributeName, entityName, entityId, controlTypeName } = elementNode;

  return {
    attributeName,
    entityName,
    entityId,
    isVisible: elementNode.props.isComponentVisible,
    isReadOnly: controlTypeName === 'ReadOnly',
  };
}

function transformTableRows(rows, tableElement) {
  const transformedRows = Object.entries(rows).reduce((acc, [key, curRow]) => {
    const transformedCols = curRow.map((curCol, colIndex) => ({
      ...curCol,
      isUpdated: undefined,
    }));

    acc[key] = transformedCols;
    return acc;
  }, {});

  return transformedRows;
}

function transformFormValues(formValues) {
  if (!formValues) return { dataRequests: [], tables: [] };

  const { dataRequests, tables, rawElements, rawElementsIndex } = formValues;

  const transformedDataRequests = Object.entries(dataRequests).map(([key, val]) => ({
    value: val,
    ...transformElement(key, rawElements, rawElementsIndex),
  }));

  const transformedTables = Object.entries(tables).map(([key, val]) => ({
    ...transformElement(key, rawElements, rawElementsIndex),
    elementName: key,
    tableRow: transformTableRows(val, rawElements[rawElementsIndex[key]]),
  }));

  return { dataRequests: transformedDataRequests, tables: transformedTables };
}

export default transformFormValues;
